import { DocumentDetailsDataStore } from 'sharebase-app/dataStores/documentDetailsDataStore';
import { ShareBaseDocument } from 'phoenix/domain';
import { AuthService } from 'phoenix/services';
import { TrackingService } from 'sharebase/services/trackingService'
import { CommentsService }  from 'sharebase/services/commentsService'
import { ActionService } from 'phoenix/services/actionService';
import { AppAction } from 'sharebase-app/components/_app/app.actions';

require('./mediaEmbeddedDetails.styles');
const template = require('./mediaEmbeddedDetails.template');

export function MediaEmbeddedDetailsDirective():ng.IDirective {
	return {
		restrict: 'E',
		controller: MediaEmbeddedDetailsController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			document: '='
		},
		link: (scope, element, attrs, vm:MediaEmbeddedDetailsController)=>{
			
		}
	}
}

MediaEmbeddedDetailsDirective.$inject = [
	
];

export class MediaEmbeddedDetailsController implements ng.IComponentController {
	public static $inject = [
		'$sce',
		'pxAuthService',
		'pxActionService',
		'sbTrackingService',
		'sbCommentsService',
		'sbaDocumentDetailsDataStore',
		'gettextCatalog'
	];

	constructor( 
		private $sce:ng.ISCEService,
		private authService:AuthService,
		private pxActionService:ActionService,
		private trackingService:TrackingService,
		private commentsService:CommentsService,
		private detailsDS,		
		private gettextCatalog:ng.gettext.gettextCatalog
	) {	
		this.loading = true;
		detailsDS.load(this.document.DocumentId).
			finally(()=>{
				this.loading = false;
			});
	}

	private document:ShareBaseDocument;
	private username:string = this.authService.displayName;
	public loading:boolean;
	public comment:string = '';
	public loadMoreCountIncrement:number = 25;
	public loadMoreCount:number = 50;


	public favoriteDocument($event) {
		this.pxActionService.emit({
			type: AppAction.Favorite,
			payload: this.document
		}, $event);
	}

	public unfavoriteDocument($event) {
		this.pxActionService.emit({
			type: AppAction.Unfavorite,
			payload: this.document
		}, $event);
	}

	public renderComment(commentText) {
		return this.$sce.trustAsHtml(this.commentsService.toHtml(commentText));
	}

	public submitComment(){
		if(!this.comment || this.comment ===''){return;}
				
		this.trackingService.trackClick('Comment Added','Media Embedded Details');

		this.commentsService
			.postComment(this.detailsDS.comments, this.comment)
			.then(comment => {
				this.detailsDS.comments.Embedded.Comments.push(comment);
				this.detailsDS.comments.TotalComments += 1;
			});
		
		this.comment = '';
	}

	public loadMoreComments(){
		this.loadMoreCount = this.loadMoreCount + this.loadMoreCountIncrement
	}

	public get downVotes(){
		if(!this.detailsDS.comments.Embedded.Comments){ return 0; }

		return this.detailsDS.comments.Embedded.Comments.filter(c=>{
			return c.CommentText.indexOf('-1') > -1;
		}).length;
	}

	public get upVotes(){
		if(!this.detailsDS.comments.Embedded.Comments){ return 0; }

		return this.detailsDS.comments.Embedded.Comments.filter(c=>{
			return c.CommentText.indexOf('+1') > -1;
		}).length;
	}

	public get hasUpVoted(){
		//used to disable buttons once a vote is added		
		return this.detailsDS.comments.Embedded.Comments.filter(c=>{
			return c.UserName === this.username && c.CommentText.indexOf('+1') > -1;
		}).length > 0;
	}
	public get hasDownVoted(){
		return this.detailsDS.comments.Embedded.Comments.filter(c=>{
			return c.UserName === this.username && c.CommentText.indexOf('-1') > -1;
		}).length > 0;
	}

	public upVote(){
		if(this.hasUpVoted || this.hasDownVoted){return;}
		//add +1 comment
		//this.trackingService.trackClick('Comment Added','Media Embedded Details');

		//existing vote comment
		this.commentsService
			.postComment(this.detailsDS.comments, '+1')
			.then(comment => {
				this.detailsDS.comments.Embedded.Comments.push(comment);
				this.detailsDS.comments.TotalComments += 1;
			});
		

	}
	
	public downVote(){
		//add -1 comment		
		if(this.hasUpVoted || this.hasDownVoted){return;}

		this.commentsService
			.postComment(this.detailsDS.comments, '-1')
			.then(comment => {
				this.detailsDS.comments.Embedded.Comments.push(comment);
				this.detailsDS.comments.TotalComments += 1;
			});

	}

	public getLink($event){
		this.pxActionService.emit({
			type: AppAction.CreateDocumentLinkShare,
			payload: this.document
		}, $event);
	}

	public get totalViews(){
		if(!this.detailsDS.activities){ return 0;}
		return this.detailsDS.activities.filter(a=>{
			return a.ConciseMessage.indexOf('[@Action=viewed]') > -1;
		}).length;
	}

	public $onChanges(changes:ng.IOnChangesObject){
		
	}
	public $onInit(){

	}
	public $onDestroy(){
			
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/mediaEmbeddedDetails/mediaEmbeddedDetails.ts